import React from 'react';
import { DayModifiers, RangeModifier } from 'react-day-picker/types/Modifiers';
import { Box, Tooltip } from '@chakra-ui/react';
import moment from 'moment';

export interface DayPickerDayProps {
  date: Date;
  modifiers: DayModifiers;
  selectedDateRange?: RangeModifier;
  showTooltips: boolean;
}
export const DayPickerDay = (props: DayPickerDayProps): JSX.Element => {
  const { date, modifiers, selectedDateRange, showTooltips } = props;

  if (modifiers.disabled) {
    return <Box>{date.getDate()}</Box>;
  }

  if (showTooltips && ((modifiers.minNightsNotReached && modifiers.bookedUp) || modifiers.minNightsNotReached)) {
    return (
      <Tooltip hasArrow label={`Keine Buchung möglich wegen Mindestaufenthalt`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  if (showTooltips && (modifiers.bookedUp && modifiers.arrivalDay)) {
    const bookedUpDate = date.getDate() + '.' + (date.getMonth() + 1);
    return (
      <Tooltip hasArrow label={`Am ${bookedUpDate} als Anreisetag verfügbar.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  if (showTooltips && (modifiers.bookedUp && modifiers.departureDay)) {
    const bookedUpDate = date.getDate() + '.' + (date.getMonth() + 1);
    return (
      <Tooltip hasArrow label={`Am ${bookedUpDate} als Anreisetag verfügbar.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  if (showTooltips && (modifiers.bookedUp && !modifiers.potentialArrivalDay && !modifiers.potentialDepartureDay)) {
    return (
      <Tooltip hasArrow label={`Dieser Tag ist ausgebucht.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }
  if (showTooltips && (modifiers.potentialArrivalDay)) {
    return (
      <Tooltip hasArrow label={`Möglicher Anreisetag.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  if (showTooltips && (modifiers.potentialDepartureDay)) {
    return (
      <Tooltip hasArrow label={`Möglicher Abreisetag.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  if (showTooltips && (selectedDateRange && !selectedDateRange.from && !selectedDateRange.to)) {
    return (
      <Tooltip hasArrow label={`Frei, jedoch keine Anreise möglich.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  if (showTooltips && (
    selectedDateRange &&
    selectedDateRange.from &&
    !selectedDateRange.to &&
    moment(date).isBefore(selectedDateRange.from)
    )
  ) {
    return (
      <Tooltip hasArrow label={`Abreisedatum muss nach dem Anreisedatum liegen.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  if (showTooltips && (selectedDateRange && selectedDateRange.from && !selectedDateRange.to)) {
    return (
      <Tooltip hasArrow label={`Frei, jedoch keine Abreise möglich.`} bg={'gray.600'}>
        <Box>{date.getDate()}</Box>
      </Tooltip>
    );
  }

  return <Box>{date.getDate()}</Box>;
};
